"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var _1 = require(".");
var NumberDropdownField = /** @class */ (function (_super) {
    __extends(NumberDropdownField, _super);
    function NumberDropdownField(key, label, isRequired, options, requiredValidationMessage, initialValue, fieldType, noSelectionLabel) {
        if (fieldType === void 0) { fieldType = _1.FieldType.DropDown; }
        var _this = _super.call(this, key, label, isRequired, options, requiredValidationMessage, initialValue, fieldType, noSelectionLabel) || this;
        _this.setNumberOptions = function (options) {
            _this.setOptions(options);
            _this.observationProvider.notifyObservers(_1.FieldActions.OptionsLoaded);
        };
        return _this;
    }
    Object.defineProperty(NumberDropdownField.prototype, "value", {
        get: function () {
            if (!this.stringValue) {
                return null;
            }
            return parseFloat(this.stringValue);
        },
        enumerable: false,
        configurable: true
    });
    return NumberDropdownField;
}(_1.BaseDropdownField));
exports.default = NumberDropdownField;
